import type { OrderActionType } from 'state/secondaryMarket/shared/actions';
import type { KycData } from 'state/secondaryMarket/shared/kyc/kyc.model';

export const secondaryMarketKycActionsFactory = <ActionType extends OrderActionType>(actionType: ActionType) => ({
  secondaryMarketKycStatusRequested: (tabId: string, clientBdrId: string, salesCountry: string) => {
    return {
      type: `SECONDARY_MARKET_${actionType}_KYC_STATUS_REQUESTED` as const,
      tabId,
      clientBdrId,
      salesCountry,
    };
  },
  secondaryMarketKycStatusReceived: (tabId: string, data: KycData) => {
    return {
      type: `SECONDARY_MARKET_${actionType}_KYC_STATUS_RECEIVED` as const,
      tabId,
      data,
    };
  },
  secondaryMarketKycStatusFailed: (tabId: string) => {
    return {
      type: `SECONDARY_MARKET_${actionType}_KYC_STATUS_FAILED` as const,
      tabId,
    };
  },
  secondaryMarketKycStatusReset: (tabId: string) => {
    return {
      type: `SECONDARY_MARKET_${actionType}_KYC_STATUS_RESET` as const,
      tabId,
    };
  },
});
